<div v-if="valueCounts" class="tt-c-summary-dim tt-c-summary-dim-select tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading tt-u-align-center">{{label}}</div>
  <div class="tt-c-summary-dim__text tt-u-align-center">{{valueCounts}}</div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-summary/summary-dim-select.html